import * as React from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
// import { createTheme, ThemeProvider } from "@mui/material/styles";

import AppNavBar from "../../components/navbar";
import bcrypt from 'bcryptjs';
import { useNavigate } from 'react-router-dom';


export default function SignInSide() {

  const navigate = useNavigate();
  
  const handleSubmit = async (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const email = data.get("email");
    const password = data.get("password");
    const apiUrl = `https://api.animal-aid.ca/api/person`;
  
    try {
      const response = await fetch(apiUrl);
      const data = await response.json();
  
      let found = false;
      for (const key in data) {
        if (Object.hasOwnProperty.call(data, key)) {
          if (data[key].email === email) {
            const passwordMatch = await bcrypt.compare(password, data[key].password);
            if (passwordMatch) {
              const userToken = JSON.stringify({ email });
              localStorage.setItem("userToken", userToken);
              console.log(`Password match found for email: ${email}`);
              found = true;
              navigate("/"); //comment out when testing form
              break;
            } else {
              console.log(`Incorrect password for email: ${email}`);
              found = true;
              break;
            }
          }
        }
      }
  
      if (!found) {
        console.log(`No match found for email: ${email}`);
      }
  
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div>
      <AppNavBar/>
      <Grid container component="main" sx={{ height: "82vh", marginTop: "5vh" }}>
        <CssBaseline />
        <Grid
          item
          xs={false}
          sm={4}
          md={7}
          sx={{
            backgroundImage: "url(https://source.unsplash.com/random/?animal)",
            backgroundRepeat: "no-repeat",
            backgroundColor: (t) =>
              t.palette.mode === "light"
                ? t.palette.grey[50]
                : t.palette.grey[900],
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
          <Box
            sx={{
              my: 8,
              mx: 4,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Sign in
            </Typography>
            <Box
              component="form"
              noValidate
              onSubmit={handleSubmit}
              sx={{ mt: 1 }}
            >
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                autoFocus
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                autoComplete="current-password"
              />
              <FormControlLabel
                control={<Checkbox value="remember" color="primary" />}
                label="Remember me"
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
              >
                Sign In
              </Button>
              <Grid container>
                <Grid item xs>
                  <Link href="#" variant="body2">
                    Forgot password?
                  </Link>
                </Grid>
                <Grid item>
                  <Link href="/signup" variant="body2">
                    {"Don't have an account? Sign Up"}
                  </Link>
                </Grid>
              </Grid>
    
            </Box>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
}
